var map = {
	"./add-player.svg": 167,
	"./facebook.svg": 3902,
	"./folder-upload.svg": 6908,
	"./instagram.svg": 673,
	"./notification.svg": 6037,
	"./psa_logo.svg": 3444,
	"./psa_logo_full.svg": 4291,
	"./sponsor-cavanagh-dental-logo.svg": 6997,
	"./sponsor-changes-for-hope-logo.svg": 5196,
	"./sponsor-crosstown-logo.svg": 739,
	"./sponsor-skin-lueur-logo.svg": 318,
	"./sponsor-whitemud-physio-logo.svg": 3439,
	"./zen-zone-clinic.svg": 3126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;